{
  "/appointment/checklocations*": "/checklocations",
  "/appointment/questionnairefields*": "/questionnairefields",
  "/healthcheckplan/userplanresult*": "/userplanresult",
  "/healthcheckplan/checksuggestionsbundle": "/checksuggestionsbundle",
  "/healthcheckplan/eligibilityquestionnairefields": "/eligibilityquestionnairefields",
  "/healthcheckplan/checkreminders": "/checkreminders",
  "/appointment/checkupsettings*": "/checkupsettings",
  "/appointment/availabledates": "/availabledates",
  "/appointment/confirmappointment": "/confirmappointment",
  "/member/calendar": "/calendar",
  "/healthcheckplan/enterpriseplans*": "/enterpriseplans",
  "/healthcheckplan/compareplans": "/compareplans",
  "/appointment/enterprisecheckupsettings": "/enterprisecheckupsettings",
  "/appointment/corporateavailabledates": "/corporateavailabledates",
  "/appointment/corporateappointments": "/corporateappointments",
  "/report/allreports": "/allreports",
  "/member/name": "/name",
  "/member/phone": "/phone",
  "/member/email": "/email",
  "/validation/verifycurrentpassword": "/verifycurrentpassword",
  "/member/changepassword": "/changepassword",
  "/appointment/appointmenthistory": "/appointmenthistory",
  "/healthcheckplan/plans": "/plans",
  "/appointment/cancelappointmentinfo": "/cancelappointmentinfo"
}
